import { Button, styled, ButtonProps } from '@mui/material';
import React from 'react';

type WhiteButtonProperties<RootComponent extends React.ElementType = 'button'> = ButtonProps<RootComponent> & {
  selected?: boolean;
  noBorder?: boolean;
};

export const WhiteButton = styled(Button, {
  shouldForwardProp: property => !['noBorder', 'selected'].includes(property as string),
})<WhiteButtonProperties<React.ElementType>>(({ selected, noBorder, theme }) => ({
  color: theme.palette.text.primary,
  textTransform: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 12px',
  borderRadius: '8px',
  cursor: selected ? 'default' : 'pointer',
  border: noBorder ? 'none' : `1px solid ${selected ? theme.palette.secondary.main : theme.palette.divider}`,
  backgroundColor: selected ? theme.palette.secondary.hover : theme.palette.background.paper,
  transition: 'all 0.2s ease-in-out',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  '&:hover': {
    boxShadow:
      '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
  },
  '& svg': {
    fontSize: '16px',
    color: theme.palette.text.disabled,
  },
})) as React.ComponentType<WhiteButtonProperties<React.ElementType>>;
